import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/FutursBilans.scss'
import dayjs from 'dayjs'

const FutursBilans = ({ bilans }) => {
  // Fonction pour déterminer la classe en fonction de la date du bilan
  const getBilanClass = (date) => {
    const diffDays = dayjs(date).diff(dayjs(), 'day')

    if (diffDays <= 2) return 'bilan-rouge' // Rouge pastel (demain ou après-demain)
    if (diffDays <= 5) return 'bilan-orange' // Orange (3 à 5 jours)
    return 'bilan-vert' // Vert (plus de 5 jours)
  }

  return (
    <div style={containerStyle}>
      {bilans.map((bilan) => (
        <Link
          key={bilan.bilanId}
          to={`bilan/${bilan.eleveId}/${bilan.bilanId}`}
          className={`futurBilan ${getBilanClass(bilan.date)}`}
        >
          <span>
            {bilan.elevePrenom} {bilan.eleveNom.slice(0, 1).toUpperCase()}
            {bilan.eleveNom.slice(1, 2)}.
          </span>
          <span>{dayjs(bilan.date).format('DD/MM/YYYY')}</span>
        </Link>
      ))}
    </div>
  )
}

// Styles extraits pour plus de lisibilité
const containerStyle = {
  position: 'fixed',
  height: 80,
  width: '100%',
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5px 100px',
  zIndex: 2,
}

export default FutursBilans
